"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createSerializationScope = createSerializationScope;
function createSerializationScope(nodeIds) {
    return { nodeIds };
}
//# sourceMappingURL=serializationScope.js.map